import { FC } from 'react';
import { ClientHistoryList } from './client-history-list';

interface IClientHistory {
  buildId: string;
  emailSentRef: number;
}

export const ClientHistory: FC<IClientHistory> = ({ emailSentRef, buildId }) => {
  return (
    <>
      <ClientHistoryList buildId={buildId} emailSentRef={emailSentRef} />
    </>
  );
};
